import React, { useEffect, useRef, useState } from 'react';
import Modal from './modal'; 
import moment from "moment";
import {fetchProductAndParty } from "../../../api/api"; 
import { useTranslation } from 'react-i18next';
import { saveOrder } from "../../../api/api";
import { fetchOrderToEdit } from '../../../api/api';
import {updateOrder} from '../../../api/api';
import {fetchBillNo} from '../../../api/api';
import { fetchCompany } from "../../../api/api";  

import { usePrivileges } from "../../../core/context/PrivilegeContext";



interface Item {
  amount: any;
  unitPrice: any;
  description: any;
  quantity: any;
  itemCode: any;
  ThirdCost: any;
  ThirdRate1: any;
  SecCostRate: any;
  SecRetailRate: any;
  ThirdUnit: any;
  SecUnit: string;
  Company: string;
  Typ: string;
  ItemC: string;
  code: string;
  Cost: any;
  ExpiryTextField: string;
  BatchTextField: string;
  MRP: any;
  UnitName: string;
  Pack: any;
  ItemNameTextField: string;
  Rate1: number;
  Tax1: number;
}

interface OrderRow {
  name: string;
  rate: string;
  tax: string;
  code: string;
  qty: string;
  discount: string;
  discountAmt: string;
  total: string;
  taxAmt: string;
  net: string;
  godown: string;
  pack: string;
  unit: string;
  cost: string;
  batch: string;
  mrp: string;
  expiry: string;
}
interface Company {
  company_name: string;
  address_english: string;
  cr_no: string;
  vat_no: string;
  mobile: string;
  bank_name: string;
  account_name: string;
  account_number: string;
  iban: string;
  logo?: string;
  logoUrl?: string; 
}

//  function to calculate row values
const calculateRowValues = (row: OrderRow): OrderRow => {
  const qty = parseFloat(row.qty) || 0;
  const rate = parseFloat(row.rate) || 0;
  const discount = parseFloat(row.discount) || 0;
  const tax = parseFloat(row.tax) || 0;

  const total = qty * rate;
  const discountAmt = (total * discount) / 100;
  const totalAfterDiscount = total - discountAmt;
  const taxAmt = (totalAfterDiscount * tax) / 100;
  const net = totalAfterDiscount + taxAmt;

  return {
    ...row,
    total: total.toFixed(2),
    discountAmt: discountAmt.toFixed(2),
    taxAmt: taxAmt.toFixed(2),
    net: net.toFixed(2),
  };
};

const OrderForm = () => {

  

 // const { privileges } = usePrivileges();

const { t } = useTranslation(); // for  arabic translation
const [showModal, setShowModal] = useState(false); //visiblity of modal window
const [searchTerm, setSearchTerm] = useState<string>('');//Stores the value from the search input to filter item list.

// product list renamed to avoid conflict with table items
const [productList, setProductList] = useState<Item[]>([]); 

const [parties, setParties] = useState<any[]>([]); 
const [dealers, setDealers] = useState<any[]>([]);
const [warehouses, setWarehouses] = useState<any[]>([]);

// selected party (for masterData)
const [selectedPartyName, setSelectedPartyName] = useState<string>("");
const [selectedPartyId, setSelectedPartyId] = useState<string>("");

// unit,rate, cost modal
const [pendingProduct, setPendingProduct] = useState<Item | null>(null);
const [unitModalOpen, setUnitModalOpen] = useState(false);

//current dates
const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
const [deliveryDate, setDeliveryDate] = useState(moment().format('YYYY-MM-DD'));
const [orderRows, setOrderRows] = useState<OrderRow[]>([]);
const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
const totalQty = orderRows.reduce((sum, row) => sum + (parseFloat(row.qty) || 0), 0);
const 
totalTotal = orderRows.reduce((sum, row) => sum + (parseFloat(row.total) || 0), 0);
const totalTaxAmt = orderRows.reduce((sum, row) => sum + (parseFloat(row.taxAmt) || 0), 0);
const totalNet = orderRows.reduce((sum, row) => sum + (parseFloat(row.net) || 0), 0);
const totalDiscountAmt = orderRows.reduce((sum, row) => sum + (parseFloat(row.discountAmt) || 0), 0);

 // tax% and dis% calculations
const [summaryDiscountPercent, setSummaryDiscountPercent] = useState('');
const [summaryDiscountAmt, setSummaryDiscountAmt] = useState('');
const [summaryTaxPercent, setSummaryTaxPercent] = useState('');
const [summaryTaxAmt, setSummaryTaxAmt] = useState('');
const [transOther, setTransOther] = useState('');

// total net total with tax,other charges, dis amt ,dis percent..
const [summaryDiscountAmtInput, setSummaryDiscountAmtInput] = useState('');
const [finalNetTotal, setFinalNetTotal] = useState('0.00');

// unit,rate, cost modal functions
const insertProductToRow = (product: Item, unit: { name?: string; rate?: any; cost?: any } | null) => {
  const rateValue = unit?.rate ?? product.Rate1 ?? 0;
  const taxValue = product.Tax1 ?? 0;
  const costValue = unit?.cost ?? product.Cost ?? 0;
  const unitName = unit?.name ?? product.Typ ?? product.UnitName ?? product.Typ ?? '';

  const newRow: OrderRow = calculateRowValues({
    name: product.ItemNameTextField || '',
    rate: rateValue.toString(),
    tax: taxValue.toString(),
    code: product.ItemC || '',
    qty: '1',
    discount: '0',
    discountAmt: '',
    total: '',
    taxAmt: '',
    net: '',
    godown: product.Company || '',
    pack: product.Pack?.toString() || '',
    unit: unitName,
    cost: costValue?.toString() || '',
    batch: product.BatchTextField || '',
    mrp: product.MRP?.toString() || '',
    expiry: product.ExpiryTextField || '',
  });

  const updatedRows = [...orderRows];

  if (selectedRowIndex === null) {
    updatedRows.push(newRow);
  } else {
    const currentRow = updatedRows[selectedRowIndex];
    const isRowEmpty = !currentRow.name && !currentRow.code;
    if (isRowEmpty) {
      updatedRows[selectedRowIndex] = newRow;
    } else {
      updatedRows.splice(selectedRowIndex + 1, 0, newRow);
    }
  }
  setOrderRows(updatedRows);
  setSelectedRowIndex(null);
};
// Master data states
  const [masterData, setMasterData] = useState({
  invno: "",
  date: "",
  customerName: "",
  customerId: "", 
  totalAmount: "",
   disc_amt: "",
  disc_perc: "",
  tax_perc: "",
  trans_charge: "",
  tot_qty: "",
  tot_tot:"",
  tot_tax_amt:"",
  contact:"",
  tax_amt:"",
  ln_disc_tot:"",
  // vehicle:"",
});

const [invoiceNo, setInvoiceNo] = useState<string>("");// state for invoice number
const [discountAmt, setDiscountAmt] = useState(0);//  states for discount fields
const [discountPerc, setDiscountPerc] = useState(0);
const [summaryDiscPercAmt, setSummaryDiscPercAmt] = useState(''); //dis perc amt

//get comapny logog details,
const [company, setCompany] = useState<Company | null>(null);

//admin privillages 
const token = localStorage.getItem("token");

let isAdmin = false;

if (token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    isAdmin = payload?.isAdmin === true;
  } catch (err) {
    console.error("Invalid token", err);
  }
}

const { privileges } = usePrivileges();

//to fetch company details for printing
useEffect(() => {
  const loadCompany = async () => {
    try {
      const data = await fetchCompany();
      const comp = data?.[0];

      if (comp) {
        let logoUrl = '';
        try {
          const parsedLogo = comp.logo ? JSON.parse(comp.logo) : null;
          logoUrl = parsedLogo?.img || '';
        } catch (err) {
          console.warn('Error parsing logo JSON:', err);
        }

        const companyMapped: Company = {
          company_name: comp.Name,
          address_english: comp.Place,
          cr_no: comp.Add2,
          vat_no: comp.tax?.toString() || '',
          mobile: comp.Ph,
          bank_name: comp.bank,
          account_name: comp.beneficiary,
          account_number: comp.account_no,
          iban: '',
          logoUrl, 
        };

        setCompany(companyMapped);
      }
    } catch (err) {
      console.error("Error loading company:", err);
    }
  };
  loadCompany();
}, []);

const handlePrint = () => {
  console.log("Printing company logo URL:", company?.logoUrl);
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  printWindow.document.write(`
    <html>
      <head>
        <title>Quotation</title>
      </head>
      <body style="font-family: Arial, sans-serif; font-size: 13px; margin: 20px;">

        <!-- HEADER -->
        <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px;">
          <div style="width: 30%; font-size: 12px; line-height: 1.4;">
            <div>${company?.company_name || ''}</div>
            <div>${company?.address_english || ''}</div>
            <div>CR: ${company?.cr_no || ''}</div>
            <div>VAT: ${company?.vat_no || ''}</div>
            <div>Mob: ${company?.mobile || ''}</div>
          </div>

          <div style="text-align: center;">
            ${company?.logoUrl ? `<img src="${company.logoUrl}" alt="Company Logo" style="width: 100px; height: auto; margin: 0 auto 5px; display: block;" />` : ''}
          <div style="font-size: 20px; font-weight: bold;">${company?.company_name || 'Company'}</div>
          <div style="border: 1px solid #000; padding: 4px; margin-top: 5px;">Quotation</div>
          </div>

          <div style="width: 30%; font-size: 12px; line-height: 1.4; text-align: right;">
            <div>وزو</div>
            <div>عنوان الشركة</div>
            <div>سجل تجاري: ${company?.cr_no || ''}</div>
            <div>ضريبة القيمة: ${company?.vat_no || ''}</div>
            <div>جوال: ${company?.mobile || ''}</div>
          </div>
        </div>

        <!-- INVOICE DETAILS (2 separate boxes) -->
        <div style="display: flex; justify-content: space-between; gap: 10px; margin-bottom: 15px;">
          <div style="width: 50%; padding: 10px; font-size: 12px; line-height: 1.6; border: 1px solid #000; border-radius: 5px;">
            <div><strong>Bill To:</strong> ${selectedPartyName || ''}</div>
            <div><strong>Address:</strong> ${''}</div>
            <div><strong>Mob:</strong> ${masterData.contact || ''}</div>
            <div><strong>VAT No:</strong> ${''}</div>
          </div>

          <div style="width: 50%; padding: 10px; font-size: 12px; line-height: 1.6; border: 1px solid #000; border-radius: 5px;">
            <div><strong>Invoice No:</strong> ${invoiceNo || ''}</div>
            <div><strong>Date:</strong> ${date}</div>
            <div><strong>D. Note:</strong> - </div>
            <div><strong>Ref:</strong> - </div>
          </div>
        </div>

        <!-- PRODUCT TABLE (no dividing lines between products) -->
        <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
          <thead>
            <tr>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">SI.No<br/>رقم</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Description<br/>وصف</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Qty<br/>كمية</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Rate<br/>سعر</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Discount<br/>خصم</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">VAT<br/>ضريبة</th>
              <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Sub Total<br/>المجموع</th>
            </tr>
          </thead>
          <tbody>
            ${orderRows.map((row, i) => `
              <tr>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: center;">${i + 1}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px;">${row.name || ''}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: center;">${row.qty || ''}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${row.rate || ''}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${row.discount || 0}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${row.tax || 0}</td>
                <td style="border-left: 1px solid #000; border-right: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${row.net || 0}</td>
              </tr>
            `).join('')}

            <!-- empty space after products -->
            <tr>
              <td style="width: 10%; border-left: 1px solid #000; border-right: 1px solid #000; height: 80px;"></td>
              <td style="width: 30%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
              <td style="width: 10%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
              <td style="width: 15%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
              <td style="width: 10%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
              <td style="width: 10%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
              <td style="width: 15%; border-left: 1px solid #000; border-right: 1px solid #000;"></td>
            </tr>

            <!-- final bottom border -->
            <tr>
              <td colspan="7" style="border:  0.5px solid #000; height: 0;"></td>
            </tr>
          </tbody>
        </table>

        <!-- BOTTOM SECTION with bank details from backend -->
        <div style="display: flex; justify-content: space-between; margin-top: 10px;">
          <div style="width: 60%; font-size: 12px;">
            <div><strong>Amount in words:</strong> ${''}</div>
            <div style="margin-top: 10px;">
              <strong>Bank Details:</strong><br/>
              Bank: ${company?.bank_name || ''}<br/>
              A/c Name: ${company?.account_name || ''}<br/>
              A/c No: ${company?.account_number || ''}<br/>
              IBAN: ${company?.iban || ''}
            </div>
          </div>

          <div style="width: 35%;">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Total / المجموع</th>
                <td style="border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${totalTotal.toFixed(2)}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Discount / الخصم</th>
                <td style="border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${totalDiscountAmt.toFixed(2)}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Net Amount / المبلغ الصافي</th>
                <td style="border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${(totalTotal - totalDiscountAmt).toFixed(2)}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">VAT (15%) / قيمة الضريبة</th>
                <td style="border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${totalTaxAmt.toFixed(2)}</td>
              </tr>
              <tr>
                <th style="border: 1px solid #000; padding: 6px; font-size: 12px;">Grand Total / المبلغ الإجمالي</th>
                <td style="border: 1px solid #000; padding: 6px; font-size: 12px; text-align: right;">${totalNet.toFixed(2)}</td>
              </tr>
            </table>
          </div>
        </div>

        <!-- FOOTER -->
        <div style="display: flex; justify-content: space-between; margin-top: 40px; font-size: 12px;">
          <div><strong>Salesman:</strong> __________</div>
          <div><strong>Received By:</strong> __________</div>
        </div>

      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
};

// refreshing of the form .(save order)
// eslint-disable-next-line react-hooks/exhaustive-deps
const handleSaveOrder = async () => {

  if (!isAdmin && !privileges.includes("save_orderform")) {
  alert("No permission to save order");
  return;
}

  try {
  const user = localStorage.getItem('username') || '';
    console.log("user", user);

    const payload = {
      masterData: {
        invno: Number(invoiceNo) || 0,
        date,
        customerName: selectedPartyName || masterData.customerName || "",
        customerId: selectedPartyId || masterData.customerId || "1",
        totalAmount: parseFloat(finalNetTotal) || 0,
        disc_amt: parseFloat(summaryDiscountAmtInput) || 0,
        disc_perc: parseFloat(summaryDiscountPercent) || 0,
        tax_perc: parseFloat(summaryTaxPercent) || 0,
        trans_charge: parseFloat(transOther) || 0,
        disc_perc_amt: parseFloat(summaryDiscountAmtInput) || 0,
        tot_qty: Number(totalQty) || 0,
        tot_tot: Number(totalTotal) || 0,
        tot_tax_amt: Number(totalTaxAmt) || 0,
        contact: masterData.contact || "",
        tax_amt: Number(summaryTaxAmt) || 0,
        ln_disc_tot: Number(totalDiscountAmt) || 0,
        user: user,
      },
      tableData: orderRows.map((row, i) => ({
        siNo: i + 1,
        itemCode: row.code,
        description: row.name,
        unit: row.unit,
        quantity: Number(row.qty) || 0,
        unitPrice: Number(row.rate) || 0,
        cost: Number(row.cost) || 0,
        pack: Number(row.pack) || 0,     
        amount: Number(row.net) || 0,
        total: Number(row.total) || 0,
        tax_amt: Number(row.taxAmt) || 0,
        tax_perc: Number(row.tax) || 0,
        disc_perc: Number(row.discount) || 0,
        disc_amt: Number(row.discountAmt) || 0,
        godown: row.godown || "MAIN", 
      })),
    };
    console.log("Payload being sent:", payload);

    const res = await saveOrder(payload);
    console.log("Order saved:", res);
    alert("Order saved successfully!");
    
    // Reset invoice + table
    setOrderRows([]);
    setSelectedPartyName("");
    setSelectedPartyId("");
    setMasterData({ ...masterData, contact: "" });
    setFinalNetTotal("0");

    // Reset 3rd form (amount fields)
    setDiscountAmt(0);
    setDiscountPerc(0);
    setSummaryDiscountPercent("");
    setSummaryDiscountAmt("");
    setSummaryTaxPercent("");
    setSummaryTaxAmt("");
    setTransOther("");
    setSummaryDiscountAmtInput("");
    setSummaryDiscPercAmt("");

    // Fetch fresh bill number only (faster)
    const response = await fetchBillNo();
    setInvoiceNo(response);
    //setBillNo(response);
    setDate(moment().format("YYYY-MM-DD")); // reset date to today

  } catch (err) {
    console.error("Error saving order:", err);
    alert("Failed to save order");
  }
};

// bill no details (getorder to edit section by enter key button)
const handleInvoiceKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "Enter") {
    try {
      const orderData = await fetchOrderToEdit(invoiceNo);

      if (orderData.master && orderData.master.length > 0) {
        const m = orderData.master[0];

        console.log("master", m);
        setTransOther(m.BillPackageField);// trans & other
        setSummaryDiscountPercent(m.BillDiscPercField); // dis%
        setSummaryDiscountAmt(m.BillDiscAmtField);// disamt
        setSummaryTaxPercent(m.BillTaxField);  // tax%
        setSummaryTaxAmt(m.BillTaxAmtField);// taxamt
        setSummaryDiscountAmtInput(m.BillDiscAmtField); // disamtinput
        setSummaryDiscPercAmt(m.BillDiscPercAmtField); // dispercamt
        
        // populate masterData
        setMasterData({
          invno: invoiceNo,
          date: m.BillDate,
          customerName: m.BillPartyName,
          customerId: m.customerId || "",
          totalAmount: m.BillNetTotalField,
          disc_amt: m.BillDiscAmtField,
          disc_perc: m.BillDiscPercField || 0,
          tax_perc: m.BillTaxPercField || 0,
          trans_charge: m.BillPackageField || 0,
          tot_qty: m.BillTotQtyField || 0,
          tot_tot: m.BillTotField || 0,
          tot_tax_amt: m.BillTaxAmtField || 0,
          contact: m.CashCardAmt || "",
          tax_amt: m.BillTaxAmtField || 0,
          ln_disc_tot: m.BillDiscAmtField || 0,
        });

        // dropdown
        setSelectedPartyId(m.customerId?.toString() || "");
        setSelectedPartyName(m.BillPartyName || "");

        //  Switch to update mode
        setIsUpdateMode(true);
      } else {
        console.log(orderData.message);
        alert("can't edit bill... status is on work.");
      }
      if (orderData.table && orderData.table.length > 0) {
        console.log("orderData.table[0] =>", orderData.table[0]);
        setOrderRows(
          orderData.table.map((row: any, i: number) => ({
            siNo: i + 1,
            code: row.ItemC,
            name: row.Item,
            unit: row.Unit,
            qty: row.Qty,
            dis: row.Dis ,
            discount: row.disc_perc ,
            discountAmt: row.Dis,
            rate: row.Rate,
            net: row.NetV,
            total: row.Total,
            taxAmt: row.TaxA,
            tax: row.TaxP,
            exp_date: row.exp_date,
            cost: row.Cst ,
            pack: row.Pack
          }))
        );
      }
    } catch (err) {
      console.error("Error fetching order:", err);
      alert("Order not found for this bill no");
    }
  }
};

//  Autofocus when modal opens 
const searchInputRef = useRef<HTMLInputElement | null>(null);  // ref for auto-focus
const [selectedIndex, setSelectedIndex] = useState(0);

useEffect(() => {
  if (showModal) {
    setSelectedIndex(0); // start at first row
    const id = setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
        searchInputRef.current.select(); 
      }
    }, 0);
    return () => clearTimeout(id);
  } else {
    setSearchTerm("");
  }
}, [showModal]);

//select one item from modal and updated according to the new modal for units selection
const handleItemSelect = (item: Item) => {
  const price = item.Rate1 ?? 0; // main rate field
  // if (price <= 0) {
  //   alert("This product cannot be added because the price is zero.");
  //   return;
  // }

  const isAlreadyAdded = orderRows.some((row) => row.code === item.ItemC);
  if (isAlreadyAdded) {
    alert("This product is already added.");
    return;
  }
   setShowModal(false);

  if (item.Typ === item.SecUnit) {
    insertProductToRow(item, {
      name: item.Typ,
      rate: item.Rate1,
      cost: item.Cost,
    });

    // Focus the first field after table
    setTimeout(() => {
      qtyRefs.current?.focus();
    }, 0);
    return;
  }

  setPendingProduct(item);
  setUnitModalOpen(true);
};

// unit,rate, cost modal
const handleUnitSelect = (unit: { name?: string; rate?: any; cost?: any }) => {
  if (!pendingProduct) return;

  const rateValue = unit?.rate ?? pendingProduct.Rate1 ?? 0;
  // if (rateValue <= 0) {
  //   alert("Selected unit cannot be added because the rate is zero.");
  //   return;
  // }

  insertProductToRow(pendingProduct,{...unit,rate:rateValue});
  setPendingProduct(null);
  setUnitModalOpen(false);

  // Focus the first field after table
  setTimeout(() => {
    qtyRefs.current?.focus();
  }, 0);
};


const handleCloseUnitModal = () => {
  setPendingProduct(null);
  setUnitModalOpen(false);
};

//modal on table
//Filters items based on the searchTerm.Sorts alphabetically by item name.
const filteredItems: Item[] = productList
  .filter((item) =>
    item.ItemNameTextField.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => a.ItemNameTextField.localeCompare(b.ItemNameTextField)); 

  // handle keyboard navigation on modal
  useEffect(() => {
  if (!showModal) return;

  const handleKey = (e: KeyboardEvent) => {
    if (filteredItems.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedIndex(prev => (prev < filteredItems.length - 1 ? prev + 1 : prev));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex(prev => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Enter") {
      e.preventDefault();
      handleItemSelect(filteredItems[selectedIndex]);
    }
  };

  window.addEventListener("keydown", handleKey);
  return () => window.removeEventListener("keydown", handleKey);
}, [showModal, filteredItems, selectedIndex]);

// handle global keydown f1 or shift for open modal
useEffect(() => {
  const handleGlobalKeyDown = (e: KeyboardEvent) => {
    console.log("global keydown:", e.key, e.keyCode);

    // F1 key check
    if (e.key === "F1" || e.keyCode === 112) {
      e.preventDefault();   // block browser help
      e.stopPropagation();
      setShowModal(true);
      return;
    }

    // Shift key check
    if (e.key === "Shift") {
      e.preventDefault();
      e.stopPropagation();
      setShowModal(true);
      return;
    }
  };

 
  window.addEventListener("keydown", handleGlobalKeyDown, { capture: true });
  console.log("F1/Shift listener attached");

  return () => {
    window.removeEventListener("keydown", handleGlobalKeyDown, { capture: true });
    console.log("F1/Shift listener removed");
  };
}, []);

//for auto scroll the modal
const rowRefs = useRef<(HTMLTableRowElement | null)[]>([]);
useEffect(() => {
  if (showModal && rowRefs.current[selectedIndex]) {
    rowRefs.current[selectedIndex]?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }
}, [selectedIndex, showModal]);

// select  modal by clicking on name
const handleNameClick = (index: number) => {
  setSelectedRowIndex(index);
  setShowModal(true);
};

// select modal by clicking on header
const handleNameHeaderClick = () => {
  setSelectedRowIndex(null); 
  setShowModal(true); //  open the modal
};

useEffect(() => {
  fetchProductAndParty()
    .then((data) => {
      console.log("Fetched data:", data);

      setProductList(data.products || []);
      setParties(data.party || []);
       setDealers(data.dealer || []); // <- save dealer data

      if (data.billNo) {
        //setBillNo(data.billNo);      //@113
        //setInvoiceNo(data.billNo.toString()); 
      }
    })
    .catch((err) => {
      console.error("Item loading error", err);
      alert("Failed to load items");
    });
}, []);

//delete one row
const handleDeleteRow = (index: number) => {

  if (!isAdmin && !privileges.includes("delete_orderform")) {
  alert("No permission to delete order row");
  return;
}

  const updatedRows = [...orderRows];
  updatedRows.splice(index, 1);
  setOrderRows(updatedRows);
};

// tax% and dis% with total net total
useEffect(() => {
  const disPct = parseFloat(summaryDiscountPercent) || 0;
  const disAmtManual = parseFloat(summaryDiscountAmtInput) || 0;
  const taxPct = parseFloat(summaryTaxPercent) || 0;
  const transAmt = parseFloat(transOther) || 0;

  let discountAmt = 0;

  if (disAmtManual > 0) {
    discountAmt = disAmtManual;
  } else {
    discountAmt = (totalNet * disPct) / 100; 
  }

  const taxableAmount = totalNet - discountAmt; 
  const taxAmt = (taxableAmount * taxPct) / 100;

  setSummaryDiscountAmt(discountAmt.toFixed(2));
  setSummaryTaxAmt(taxAmt.toFixed(2));

  const finalNet = taxableAmount + taxAmt + transAmt;
  setFinalNetTotal(finalNet.toFixed(2));
}, [
  summaryDiscountPercent,
  summaryDiscountAmtInput,
  summaryTaxPercent,
  transOther,
  totalNet 
]);

//calculations of row fields    
const handleInputChange = (
  rowIndex: number,
  field: keyof OrderRow,
  value: string | number
) => {
  const updatedRows = [...orderRows];

  if (field === "rate") {
    updatedRows[rowIndex][field] = String(value) as any;
  } else {
    updatedRows[rowIndex][field] = value as any;
  }

  // --- Recalculate row values ---
  const r = updatedRows[rowIndex];
  const qty = parseFloat(String(r.qty)) || 0;
  const rate = parseFloat(String(r.rate)) || 0;
  const tax = parseFloat(String(r.tax)) || 0;

  const totalBeforeDiscount = qty * rate;

  let discountAmt = parseFloat(String(r.discountAmt)) || 0;
  let discount = parseFloat(String(r.discount)) || 0;

  if (field === "discountAmt") {
    discount = totalBeforeDiscount !== 0 ? (discountAmt / totalBeforeDiscount) * 100 : 0;
    updatedRows[rowIndex].discount = discount.toFixed(2);
  } else {
    discountAmt = (totalBeforeDiscount * discount) / 100;
    updatedRows[rowIndex].discountAmt = discountAmt.toFixed(2);
  }

  const total = totalBeforeDiscount - discountAmt;
  const taxAmt = (total * tax) / 100;
  const net = total + taxAmt;

  updatedRows[rowIndex].total = total.toFixed(2);
  updatedRows[rowIndex].taxAmt = taxAmt.toFixed(2);
  updatedRows[rowIndex].net = net.toFixed(2);

  setOrderRows(updatedRows);
};

// update function
const handleUpdateOrder = async () => {

    if (!isAdmin && !privileges.includes("update_orderform")) {
  alert("No permission to update order form");
  return;
}
  
  try {
    const user = localStorage.getItem('email') || '{}';
    const payload = {
      masterData: {
        invno: Number(invoiceNo) || 0,
        date,
        customerName: selectedPartyName || masterData.customerName || "",
        customerId: selectedPartyId || masterData.customerId || "1",
        totalAmount: parseFloat(finalNetTotal) || 0,
        disc_amt: parseFloat(summaryDiscountAmtInput) || 0,
        disc_perc: parseFloat(summaryDiscountPercent) || 0,
        tax_perc: parseFloat(summaryTaxPercent) || 0,
        trans_charge: parseFloat(transOther) || 0,
        disc_perc_amt: parseFloat(summaryDiscountAmtInput) || 0,
        tot_qty: Number(totalQty) || 0,
        tot_tot: Number(totalTotal) || 0,
        tot_tax_amt: Number(totalTaxAmt) || 0,
        contact: masterData.contact || "",
        tax_amt: Number(summaryTaxAmt) || 0,
        ln_disc_tot: Number(totalDiscountAmt) || 0,
        user: user,
      },
      tableData: orderRows.map((row, i) => ({
        siNo: i + 1,
        itemCode: row.code,
        description: row.name,
        unit: row.unit,
        quantity: Number(row.qty) || 0,
        unitPrice: Number(row.rate) || 0,
        amount: Number(row.net) || 0,
        total: Number(row.total) || 0,
        tax_amt: Number(row.taxAmt) || 0,
        tax_perc: Number(row.tax) || 0,
        disc_perc: Number(row.discount) || 0,
        disc_amt: Number(row.discountAmt) || 0,
      })),
    };

    const res = await updateOrder(payload);

    if (res.success) {
      alert("Order updated successfully");

      // Exit update mode
      setIsUpdateMode(false);

      // Reset invoice + table
      setOrderRows([]);
      setSelectedPartyName("");
      setSelectedPartyId("");
      setMasterData({ ...masterData, contact: "" });
      setFinalNetTotal("0");

      // Reset 3rd form (amount fields)
      setDiscountAmt(0);
      setDiscountPerc(0);
      setSummaryDiscountPercent("");
      setSummaryDiscountAmt("");
      setSummaryTaxPercent("");
      setSummaryTaxAmt("");
      setTransOther("");
      setSummaryDiscountAmtInput("");
      setSummaryDiscPercAmt("");

      // Fetch fresh bill number only
      const response = await fetchBillNo();
      setInvoiceNo(response);
      //setBillNo(response);
      setDate(moment().format("YYYY-MM-DD")); // reset date to today
    } else {
      alert("Failed to update order.");
    }
  } catch (err) {
    alert("Error updating order");
    console.error(err);
  }
};

const [contact, setContact] = useState("");
const handleClearForm = async () => {
  setOrderRows([]);
    setSelectedPartyName("");
    setInvoiceNo("");
    setContact("");
    setSelectedPartyId("");
    setFinalNetTotal("0");
    setMasterData({
    ...masterData,
    contact: "",});

    //  Reset 3rd form (amount fields)
    setDiscountAmt(0);
    setDiscountPerc(0);
    setSummaryDiscountPercent("");
    setSummaryDiscountAmt("");
    setSummaryTaxPercent("");
    setSummaryTaxAmt("");
    setTransOther("");
    setSummaryDiscountAmtInput("");
    setSummaryDiscPercAmt('');

    // ✅ Add this line — it hides the “Editing Order” label
  setIsUpdateMode(false);
    
    //  Fetch fresh bill no for new order
    const response = await fetchBillNo();
      
        setInvoiceNo(response); 
      setDate(moment().format("YYYY-MM-DD")); // reset date to today
  // reset all other states here
};

const [isUpdateMode, setIsUpdateMode] = useState(false);

// check if any row has rate < cost 
const hasInvalidRate = orderRows.some((row) => {
  const cost = parseFloat(row.cost) || 0;
  const rate = parseFloat(row.rate) || 0;
  //  invalid if:
  // 1. rate is greater than 0 and less than cost (your existing rule)
  // 2. OR rate is exactly 0
  return (rate > 0 && rate < cost) || (rate === 0 && cost > 0);   // only invalid if rate is a valid number and less than cost
});

// Fetch invoice number on form load
useEffect(() => {
  const getInvoiceNo = async () => {
    try {
      // Only fetch if not in update mode
      if (!isUpdateMode) {
        const response = await fetchBillNo();
      
        setInvoiceNo(response); 
        //setBillNo(response);
      }
    } catch (error) {
      console.error("Failed to fetch invoice number:", error);
    }
  };

  getInvoiceNo();
}, [isUpdateMode]);

//auto focus on partyname
const partyRef = useRef<HTMLSelectElement>(null);
useEffect(() => {
  if (partyRef.current) {
    partyRef.current.focus();
  }
}, []);

const qtyRefs = useRef<HTMLInputElement>(null);//autofocus after the modal qtyfield

const disAmtRef = useRef<HTMLInputElement>(null); //for autofocusing after table

//save order by enter button
const transOtherRef = useRef<HTMLInputElement>(null);
const saveBtnRef = useRef<HTMLButtonElement>(null);

useEffect(() => {
  const handleEnter = async (e: KeyboardEvent) => {
    if (e.key === "Enter" && document.activeElement === transOtherRef.current) {
      e.preventDefault(); 
      try {
        await handleSaveOrder();
      } catch (err) {
        console.error("Failed to save order via Enter key:", err);
      }
    }
  };

  window.addEventListener("keydown", handleEnter);
  return () => window.removeEventListener("keydown", handleEnter);
}, [handleSaveOrder]);
 

    return (
    <div className="page-wrapper">
  <div className="content container-fluid">
    <div className="page-header">
      <div className="row align-items-center">
        <div className="col">
          <h3 className="page-title">{t('createOrder')}</h3>
          <ul className="breadcrumb">
            <li className="breadcrumb-item">{t('dashboard')}</li>
            <li className="breadcrumb-item active">{t('createOrder')}</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-md-12">
        <form>
          <div className="row">
            
            <div className="col-md-3">
                    <div className="form-group">
                      <label className="mb-1">
                        {t('invoiceNo')}
                      </label>

                      {isUpdateMode && (
                        <div className="alert alert-warning py-1 px-2 mb-2">
                          {t('Editing Order')}
                        </div>
                      )}
                      <input
                        type="number"
                        className="form-control"
                        value={invoiceNo}
                        onChange={(e) => setInvoiceNo(e.target.value)}
                        onKeyDown={handleInvoiceKeyDown}
                      /> 
                     </div>
                  </div> 

            <div className="col-md-3">
              <div className="form-group">
                <label className="mb-1">{t('creditParty')}</label>
                <select
                  ref={partyRef}
                  className="form-select"
                  value={selectedPartyName}
                  onChange={(e: { target: { value: any; }; }) => {
                    const name = e.target.value;
                    setSelectedPartyName(name);
                    const p = parties.find((x) => x?.Name === name);
                    const id =
                      p?.id ??
                      p?.Id ??
                      p?.CstId ??
                      p?.cst_id ??
                      p?.CustomerId ??
                      "";
                    setSelectedPartyId(id?.toString?.() ?? "");
                    
                    setMasterData((m) => ({
                      ...m,
                      customerName: name,
                      customerId: id?.toString?.() ?? "",
                    }));
                  }}
                >
                  <option value="">{t('selectCreditParty')}</option>
                  {parties?.map((party, index) => (
                    <option key={index} value={party.Name}>
                      {party.Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-3">
                <div className="form-group">
                  <label className="mb-1">{t('contact')}</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={t('enterContact')}
                    value={masterData.contact}
                    onChange={(e) =>
                      setMasterData({ ...masterData, contact: e.target.value })
                    }
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              </div>


            <div className="col-md-3">
              <div className="form-group">
                <label className="mb-1">{t('dealer')}</label>
                <select className="form-select">
                  <option value="">{t('nil')}</option>
                  {dealers?.map((dealer, index) => (
                    <option key={index} value={dealer.Name}>
                      {dealer.Name}
                    </option>
                  ))}
                </select>
              </div>
            </div>


            <div className="col-md-3">
              <div className="form-group">
                <label className="mb-1">{t('date')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label className="mb-1">{t('deliveryDate')}</label>
                <input
                  type="date"
                  className="form-control"
                  value={deliveryDate}
                  onChange={(e) => setDeliveryDate(e.target.value)}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="form-group">
                <label className="mb-1">{t('vehicle')}</label>
                <input type="text" className="form-control" placeholder={t('enterVehicle')} />
              </div>
            </div>

            <div className="col-md-3">
            <div className="form-group">
              <label className="mb-1">{t('warehouse')}</label>
              <select className="form-select">
                <option value="MAIN">MAIN</option>
              </select>
            </div>
          </div>


          </div>
        </form>
      </div>
    </div>
 
        {/* Table */}
        <div className="table-responsive mt-4">
            <table className="table table-bordered">
                <thead className="thead-light">
                <tr>
                    <th>{t('siNo')}</th>
                    <th>{t('code')}</th>
                    <th onClick={handleNameHeaderClick} style={{ cursor: 'pointer' }}>  {t('name')} </th>
                    <th>{t('qty')}</th>
                    <th>{t('rate')}</th>
                    <th>{t('discountPercent')}</th>
                    <th>{t('discountAmount')}</th>
                    <th>{t('total')}</th>
                    <th>{t('taxPercent')}</th>
                    <th>{t('taxAmount')}</th>
                    <th>{t('netTotal')}</th>
                    <th>{t('godown')}</th>
                    <th>{t('pack')}</th>
                    <th>{t('unit')}</th>
                    <th>{t('cost')}</th>
                    <th>{t('batch')}</th>
                    <th>{t('mrp')}</th>
                    <th>{t('expiry')}</th>
                    <th>{t('delete')}</th>
                </tr>
                </thead>
               <tbody>
                {orderRows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{rowIndex + 1}</td>
                <td>
                <input
                  value={row.code}
                  onChange={(e) => handleInputChange(rowIndex, 'code', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '40px' }}
                />
              </td>

              <td>
                <input
                  value={row.name}
                  onChange={(e) => handleInputChange(rowIndex, 'name', e.target.value)}
                  onClick={() => handleNameClick(rowIndex)}
                  className="form-control form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '120px' }}
                />
              </td>

              <td>
                <input
                  value={row.qty}
                  onChange={(e) => handleInputChange(rowIndex, 'qty', e.target.value)}
                  className="form-control-sm"
                  ref={qtyRefs}
                   onFocus={(e) => e.target.select()}   // auto-select text
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '20px' }}
                />
              </td>

              <td>
                <input
                  value={row.rate}
                  onChange={(e) => handleInputChange(rowIndex, 'rate', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
                />
              </td>

              <td>
              <input
                value={row.discount}
                onChange={(e) => handleInputChange(rowIndex, 'discount', e.target.value)}
                className="form-control-sm"
                style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
              />
            </td>

            <td>
              <input
                value={row.discountAmt}
                onChange={(e) => handleInputChange(rowIndex, 'discountAmt', e.target.value)}
                className="form-control-sm"
                style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
              />
            </td>

              <td>
                <input
                  value={row.total}
                  onChange={(e) => handleInputChange(rowIndex, 'total', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
                />
              </td>

              <td>
                <input
                  value={row.tax}
                  onChange={(e) => handleInputChange(rowIndex, 'tax', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
                />
              </td>

              <td>
                <input
                  value={row.taxAmt}
                  onChange={(e) => handleInputChange(rowIndex, 'taxAmt', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
                />
              </td>

              <td>
                <input
                  value={row.net}
                  onChange={(e) => handleInputChange(rowIndex, 'net', e.target.value)}
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '70px' }}
                />
              </td>

              <td>
  <input
    value={row.godown === "0" || !row.godown ? "MAIN" : row.godown}
    onChange={(e) => handleInputChange(rowIndex, "godown", e.target.value)}
    tabIndex={-1}
    className="form-control-sm"
    style={{ border: "none", background: "transparent", boxShadow: "none", outline: "none", padding: 0, fontSize: "inherit", width: "60px" }}
  />
</td>


              <td>
                <input
                  value={row.pack}
                  onChange={(e) => handleInputChange(rowIndex, 'pack', e.target.value)}
                   tabIndex={-1}   
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '20px' }}
                />
              </td>

              <td>
                <input
                  value={row.unit}
                  onChange={(e) => handleInputChange(rowIndex, 'unit', e.target.value)}
                   tabIndex={-1} 
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '30px' }}
                />
              </td>

              <td>
                <input
                  value={row.cost}
                  onChange={(e) => handleInputChange(rowIndex, 'cost', e.target.value)}
                   tabIndex={-1}  
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '50px' }}
                />
              </td>

              <td>
                <input
                  value={row.batch}
                  onChange={(e) => handleInputChange(rowIndex, 'batch', e.target.value)}
                   tabIndex={-1} 
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '30px' }}
                />
              </td>

              <td>
                <input
                  value={row.mrp}
                  onChange={(e) => handleInputChange(rowIndex, 'mrp', e.target.value)}
                   tabIndex={-1}  
                  className="form-control-sm"
                  style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '30px' }}
                />
              </td>
<td>
  <input
    type="date"
    value={row.expiry || new Date().toISOString().split("T")[0]}
    onChange={(e) => handleInputChange(rowIndex, 'expiry', e.target.value)}
    tabIndex={-1}
    className="form-control-sm"
    style={{ border: 'none', background: 'transparent', boxShadow: 'none', outline: 'none', padding: 0, fontSize: 'inherit', width: '100px' }}
  />
</td>


              <td>
                {privileges.includes("delete_orderform") && (
  <button
    type="button"
    onClick={() => handleDeleteRow(rowIndex)}
    tabIndex={-1}
    className="btn btn-sm"
    style={{
      backgroundColor: "#dc3545",
      color: "#fff",
      padding: "2px 10px",
      fontSize: "12px",
      border: "none",
      borderRadius: "4px",
    }}
  >
    {t("delete")}
  </button>
)}
              </td>
                  </tr>
                ))}
              </tbody>
              </table>
            </div>

        {/* Table Ends */}
        <div className="d-flex mt-2" style={{ gap: '20px', justifyContent: 'flex-start' }}>
          <div style={{ minWidth: '80px' }}>
            <label className="form-label">{t('Qty Total')}</label>
            <div className="form-control form-control-sm">{totalQty}</div>
          </div>

          <div style={{ minWidth: '100px' }}>
            <label className="form-label">{t('Total')}</label>
            <div className="form-control form-control-sm">{totalTotal.toFixed(2)}</div>
          </div>

        <div style={{ minWidth: '100px' }}>
            <label className="form-label">{t('TotalTax')}</label>
            <div className="form-control form-control-sm">{totalTaxAmt.toFixed(2)}</div>
        </div>

          <div style={{ minWidth: '100px' }}>
            <label className="form-label">{t('TotalDiscount')}</label>
            <div className="form-control form-control-sm">{totalDiscountAmt.toFixed(2)}</div>
          </div>


        <div style={{ minWidth: '100px' }}>
          <label className="form-label">{t('Net Total')}</label>
          <div className="form-control form-control-sm">{totalNet.toFixed(2)}</div>
        </div>
      </div>

      {/* 3rd form */}
        <div className="row mt-4">    
            <div className="row">
              {/* Dis Amt */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t('Dis Amt')}</label>
                  <div className="d-flex gap-2">
                   <input ref={disAmtRef}  className="form-control w-75" placeholder={t("enterDisAmt")}value={summaryDiscountAmtInput} onChange={(e) => setSummaryDiscountAmtInput(e.target.value)}/>
                  </div>
                </div>
              </div>

              {/* Dis % */}
      <div className="col-md-6">
        <div className="form-group">
          <label>{t('Dis %')}</label>
          <div className="d-flex gap-2">
            <input className="form-control w-75" placeholder={t("enterDisPercent")} value={summaryDiscountPercent} onChange={(e) => setSummaryDiscountPercent(e.target.value)}/>
            <input className="form-control w-25" value={summaryDiscountAmt}
              readOnly
              tabIndex={-1}   // <-- skip on Tab
            />
          </div>
        </div>
      </div>

      {/* Tax % */}
      <div className="col-md-6 mt-3">
        <div className="form-group">
          <label>{t('Tax %')}</label>
          <div className="d-flex gap-2">
            <input className="form-control w-75" placeholder={t("enterTaxPercent")} value={summaryTaxPercent} onChange={(e) => setSummaryTaxPercent(e.target.value)}/>
            <input className="form-control w-25" value={summaryTaxAmt}
              readOnly
              tabIndex={-1}   // <-- skip on Tab
            />
          </div>
        </div>
      </div>


      {/* Trans & Other */}
      <div className="col-md-6 mt-3">
        <div className="form-group">
          <label>{t('Trans & Other')}</label>
               <input  ref={transOtherRef} className="form-control" placeholder={t("enterCharges")} value={transOther} onChange={(e) => setTransOther(e.target.value)}
                onBlur={() => {
                  setTimeout(() => saveBtnRef.current?.focus(), 0);
                }}
               />
            </div>
         </div>

      {/* Net Total */}
      <div className="col-md-6 mt-3">
          <div className="form-group">
             <label>{t('Net Total')}</label>
              <input className="form-control" placeholder={t("enterNetTotal")} value={finalNetTotal}
              readOnly
              onFocus={() => {
                setTimeout(() => saveBtnRef.current?.focus(), 0);
              }}
              />
          </div>
        </div>
      </div>

       {/* buttons */}
           <div className="row mt-4 mb-5"> 
            <div className="col-md-12 d-flex justify-content-end gap-2">
            <button
  ref={saveBtnRef}
  type="button"
  className="btn text-white"
  style={{
    backgroundColor: hasInvalidRate ? "#6c757d" : "#007bff",
    outline: "none",
    border: "none",
    transition: "all 0.2s ease-in-out",
    cursor: hasInvalidRate ? "not-allowed" : "pointer",
  }}
  onFocus={(e) => {
    if (hasInvalidRate) return;
    e.currentTarget.style.backgroundColor = "#0b5ed7";
    e.currentTarget.style.boxShadow =
      "0 0 0 0.25rem rgba(13, 110, 253, 0.5)";
  }}
  onBlur={(e) => {
    e.currentTarget.style.backgroundColor = hasInvalidRate
      ? "#6c757d"
      : "#007bff";
    e.currentTarget.style.boxShadow = "none";
  }}
  onMouseEnter={(e) => {
    if (hasInvalidRate) return;
    e.currentTarget.style.backgroundColor = "#0b5ed7";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = hasInvalidRate
      ? "#6c757d"
      : "#007bff";
  }}
  onClick={handleSaveOrder}
 disabled={
  hasInvalidRate ||
  (!isAdmin && !privileges.includes("save_orderform"))
}
>
  {t("save")}
</button>   

               <button type="button" className="btn text-dark" style={{ backgroundColor: '#ffc107' }}
               onClick={handlePrint}
               >
                 {t('print')}
              </button>

              {/* <button type="button" className="btn text-white" style={{ backgroundColor: '#dc3545' }}>
                {t('delete')}
              </button> */} 

              <button type="button" className="btn text-white" onClick={handleClearForm} style={{ backgroundColor: '#fd7e14' }}>
                {t('clear')}
              </button>
              <button
  type="button"
  className="btn text-white"
  style={{
    backgroundColor: hasInvalidRate ? "#6c757d" : "#28a745",
  }}
  onClick={handleUpdateOrder}
  disabled={hasInvalidRate || (!isAdmin && !privileges.includes("update_orderform"))}
>
  {t("update")}
</button>
            </div>
          </div>
        </div>
      </div>

      <Modal
    show={showModal}
    onClose={() => {
      setShowModal(false);
      setSearchTerm(""); // Clear search when modal closes
    }}
    title={t("selectItem")}
    size="large"
  >
    <>
      <style>
        {`
          .modal-table tr:hover {
            background-color: #e6f0ff;
            cursor: pointer;
          }
        `}
      </style>

      <div
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "800px",
          width: "90%",
          margin: "10px auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <h4 style={{ marginBottom: "15px", color: "#333" }}>{t("searchItems")}</h4>

        {/*  Search input with auto-focus */}
        <input
          ref={searchInputRef} // attach ref
          type="text"
          placeholder={t("searchItemPlaceholder")}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
        />

        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          <table
            className="modal-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "left",
            }}
          >
            <thead>
              <tr>
                <th style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>
                  {t("name")}
                </th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>
                  {t("price")}
                </th>
                <th style={{ borderBottom: "1px solid #ccc", padding: "10px" }}>
                  {t("tax")}
                </th>
              </tr>
            </thead>
           <tbody>
              {filteredItems.length > 0 ? (
                filteredItems.map((item, index) => (
                  <tr
                    key={index}
                     ref={(el) => (rowRefs.current[index] = el)}   // attach ref
                    onClick={() => handleItemSelect(item)}
                    style={{
                      cursor: "pointer",
                      backgroundColor: index === selectedIndex ? "#cce5ff" : "transparent", // highlight selected row
                    }}
                  >
                    <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                      {item.ItemNameTextField}
                    </td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                      {item.Rate1}
                    </td>
                    <td style={{ padding: "10px", borderBottom: "1px solid #eee" }}>
                      {item.Tax1}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={3}
                    style={{
                      padding: "10px",
                      textAlign: "center",
                      color: "#999",
                    }}
                  >
                    {t("noMatchingItemsFound")}
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      </div>
    </>
  </Modal>

    {/*second modal for units */}
  <Modal
      show={unitModalOpen}
      onClose={handleCloseUnitModal}
      title={t('selectUnit')}
      size="small"
    >
  <div style={{ padding: 10 }}>
    <h6 style={{ marginBottom: 6, fontWeight: 'bold' }}>
      {pendingProduct?.ItemNameTextField}
    </h6>

    <div style={{ maxHeight: 250, overflowY: 'auto' }}>
      <table className="table table-hover table-sm" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.9rem' }}>
        <thead style={{ background: '#f8f9fa' }}>
          <tr>
            <th style={{ padding: '6px' }}>{t('unit')}</th>
            <th style={{ padding: '6px' }}>{t('rate')}</th>
            <th style={{ padding: '6px' }}>{t('cost')}</th>
          </tr>
        </thead>
        <tbody>
          {pendingProduct &&
            [
              { name: pendingProduct.Typ, rate: pendingProduct.Rate1, cost: pendingProduct.Cost },
              { name: pendingProduct.SecUnit, rate: pendingProduct.SecRetailRate, cost: pendingProduct.SecCostRate },
              { name: pendingProduct.ThirdUnit, rate: pendingProduct.ThirdRate1, cost: pendingProduct.ThirdCost },
            ]
              .filter((u) => u.name && String(u.name).trim() !== '')
              .map((u, i) => (
                <tr key={i} style={{ cursor: 'pointer' }} onClick={() => handleUnitSelect({ name: u.name, rate: u.rate, cost: u.cost })}>
                  <td style={{ padding: '6px' }}>{u.name}</td>
                  <td style={{ padding: '6px' }}>{u.rate ?? ''}</td>
                  <td style={{ padding: '6px' }}>{u.cost ?? ''}</td>
                </tr>
              ))}
          {!pendingProduct && (
            <tr>
              <td colSpan={3} style={{ padding: 8, textAlign: 'center', color: '#666' }}>
                {t('noUnitsFound')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</Modal>
</div>
  );
};

export default OrderForm;